import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  name: 'ContextMenu',
  components: {},
  data: function data() {
    return {
      top: 0,
      left: 0,
      menuListent: null
    };
  },
  computed: _objectSpread({}, mapGetters('contextmenu', ['visible', 'menuItem', 'dataSet', 'event'])),
  watch: {
    visible: {
      handler: function handler(val) {
        if (val) {
          this.$refs.contextmenu.onfocus = true;
        }
      }
    },
    event: {
      handler: function handler(val) {
        if (val) {
          // console.log('event', val)
          var docRect = document.documentElement.getBoundingClientRect();
          var menuRect = this.$refs.contextmenu.getBoundingClientRect();
          if (val.clientY < 0) {
            this.top = 0;
          } else if (docRect.height - val.clientY < menuRect.height) {
            this.top = val.clientY - menuRect.height;
          } else {
            this.top = val.clientY;
          }
          if (val.clientX < 0) {
            this.left = 0;
          } else if (docRect.width - val.clientX < menuRect.width) {
            this.left = val.clientX - menuRect.width;
          } else {
            this.left = val.clientX;
          }
        }
      }
    }
  },
  created: function created() {
    var that = this;
    this.menuListent = document.addEventListener('click', function (_this) {
      if (that.visible) {
        that.$store.dispatch('contextmenu/close');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.menuListent);
  },
  methods: {
    // 关闭弹框后提示父组件
    close: function close() {
      this.$store.dispatch('contextmenu/close');
    },
    handleCommand: function handleCommand(e) {
      var rowData = _objectSpread(_objectSpread({}, e), this.dataSet);
      if (e.check) {
        this.$store.dispatch('checkpw/open', rowData);
      } else {
        e.handleClick(rowData);
      }
      this.close();
    },
    handleHideMenu: function handleHideMenu() {
      this.close();
    }
  }
};